module.exports = __webpack_public_path__ + "img/xg2.6a4a7b70.png";